import '~/components/account/account.module';
import accountTemplate from './account.html';
import accountInfosTemplate from './infos/account-infos.html';
import accountPasswordTemplate from './password/account-password.html';
import accountWorkflowTemplate from './workflow/account-workflow.html';
import accountMailingTemplate from './mailing/account-mailing.html';

import './account.scss';

export default {
	path:         '/account/:page?',
	redirectTo:   (
		/** @type {import('angular').route.IRouteParamsService} */ routeParameters,
		/** @type {any} */ current,
	) => {
		if (!routeParameters.page) {
			return '/account/infos';
		}

		return current;
	},
	template:     (/** @type {import('angular').route.IRouteParamsService} */ routeParameters) => {
		if (routeParameters.page === 'infos') {
			return accountInfosTemplate;
		}

		if (routeParameters.page === 'password') {
			return accountPasswordTemplate;
		}

		if (routeParameters.page === 'workflow') {
			return accountWorkflowTemplate;
		}

		if (routeParameters.page === 'mailing') {
			return accountMailingTemplate;
		}

		return accountTemplate;
	},
	title:        'menu.account',
};
